module.exports = __webpack_public_path__ + "img/Componente 35 – 1.6ed74c03.svg";